// currently running cookies here
export const ARGOS_CARD_COOKIE = 'Argos_Card_Test_Group_1'
export const ARGOS_CARD_COOKIE_A = 'a'
export const ARGOS_CARD_COOKIE_B = 'b'
export const ARGOS_CARD_DEFAULT = ARGOS_CARD_COOKIE_A

export const getVariantCookies = (reqCookieArr = []) => {
  const allVariantTests = []

  reqCookieArr.forEach((test) => {
    const { testName, testVal } = test
    if (testName === ARGOS_CARD_COOKIE) {
      if (ARGOS_CARD_COOKIE_A || ARGOS_CARD_COOKIE_B) allVariantTests.push({ testName: ARGOS_CARD_COOKIE, testVal })
      else allVariantTests.push({ testName: ARGOS_CARD_COOKIE, testVal: ARGOS_CARD_DEFAULT })
    }
  })
  return allVariantTests
}
